import { createContext } from 'react';
import Company, { initialCompanyValue } from '../../models/Company';

const CompanyContext = createContext<{ company: Company; setCompany: (company: Company) => void }>({
    company: initialCompanyValue,
    setCompany: () => {},
});

export default CompanyContext;
